var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('AutoriaIndex',{attrs:{"showvolver":true,"isgeneral":true}}),_c('p',{staticClass:"mb-14 pt-8"}),_c('LibreIndex',{attrs:{"showvolver":false,"isgeneral":true}}),_c('p',{staticClass:"mb-14 pt-8"}),_c('AltoRenIndex',{attrs:{"showvolver":false,"isgeneral":true}}),_c('p',{staticClass:"mb-14 pt-8"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }